import React from 'react';
import { Box } from '@mui/material';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Portfolio from './components/Portfolio';
import ExtraCurricular from './components/ExtraCurricular';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { useTheme } from './context/ThemeContext';
import ErrorBoundary from './ErrorBoundary';

function App() {
  // Use theme context
  useTheme();
  
  return (
    <Box sx={{ 
      backgroundColor: 'background.default', 
      color: 'text.primary', 
      minHeight: '100vh',
      cursor: 'auto' // Explicitly set normal cursor
    }}>
      <AnimatePresence mode="wait">
        <ErrorBoundary componentName="Navbar">
          <Navbar />
        </ErrorBoundary>
        
        <ErrorBoundary componentName="Hero">
          <Hero />
        </ErrorBoundary>
        
        <ErrorBoundary componentName="About">
          <About />
        </ErrorBoundary>
        
        <ErrorBoundary componentName="Portfolio">
          <Portfolio />
        </ErrorBoundary>
        
        <ErrorBoundary componentName="ExtraCurricular">
          <ExtraCurricular />
        </ErrorBoundary>
        
        <ErrorBoundary componentName="Contact">
          <Contact />
        </ErrorBoundary>
        
        <ErrorBoundary componentName="Footer">
          <Footer />
        </ErrorBoundary>
      </AnimatePresence>
    </Box>
  );
}

export default App; 